<div class="app-top main-div">
  <router-outlet></router-outlet>
</div>
